export default "__VITE_ASSET__DWcwxtHX__"